import configurations from '../../../helpers/misc/configurations'

const validate = values => {
	const errors = {}
	
	if (!values.email) {
		errors.email = `Email can't be blank`
	} else {
		if (!configurations.emailRegex.test(values.email)) {
			errors.email = `Invalid email`
		}
	}

	if (!values.fullname) {
		errors.fullname = `Full Name can't be blank`
	}

	if (!values.password) {
		errors.password = `Password can't be blank`
	} else {
		if (values.password.length < 6) {
			errors.password = 'Please choose a password with at least 6 characters'
		}
	}

	if (!values.company_name) {
		errors.company_name = `Company Name can't be blank`
	} else{
		if(values.company_name.length > 65){
			errors.company_name = `Company Name cannot more than 65 characters`
		}
	}

	if (!values.total_roles_description) {
		errors.total_roles_description = `Please select the number of roles`
	}

	if (!values.assist_description) {
		errors.assist_description = `Description can't be blank`
	}

	return errors
}

export default validate
